import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import { useAuth, useUser } from "@clerk/clerk-react";
import Home from "./Pages/Home/Home";

import Layout from "Layout/Layout";
import Certificates from "Pages/Certificates/Certificates";
import SingleCertificate from "Pages/Certificates/Components/SingleCertificate";
import StripePayment from "Pages/ChallengeBilling/PaymentsProviders/StripePayment";
import ChallengeCreatedSuccessfully from "Pages/ChallengeCreatedSuccessfully/ChallengeCreatedSuccessfully";
import ChallengeLanding from "Pages/ChallengeLanding/ChallengeLanding";
import ChallengeOverview from "Pages/ChallengeOverview/ChallengeOverview";
import ChallengePerformance from "Pages/ChallengePerformance/ChallengePerformance";
import ChallengeRules from "Pages/ChallengeRules/ChallengeRules";
import ChallengeTrades from "Pages/ChallengeTrades/ChallengeTrades";
import CreateChallenge from "Pages/CreateChallenge/CreateChallenge";
import CreatePaidChallenge from "Pages/CreateChallenge/CreatePaidChallenge";
import InProgressCreation from "Pages/InProgressCreation/InProgressCreation";
import LoginLink from "Pages/LoginSendLink/LoginLink";
import NotFound from "Pages/NotFound/NotFound";
import NotificationPage from "Pages/Notifications/NotificationPage";
import OtpVerification from "Pages/OtpVerification/OtpVerification";
import Profile from "Pages/Profile/Profile";
import Wallet from "Pages/Wallet/Wallet";
import { setupNotifications } from "Shared/notifications/Firebase";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Toaster } from "sonner";
import Login from "./Pages/Login/Login";
import { createChallenge } from "./Redux/ChallengeSetup/ChallengeSetupAction";
import StripeAddon from "./Pages/ChallengeRules/ChallengeRuleComponents/CheckoutPopup/StripePayment";
import TermsNConditions from "Pages/TermsNConditions/TermsNConditions";
import PrivacyPolicy from "Pages/PrivacyPolicy/PrivacyPolicy";
import Loading from "Components/Loading/Loading";
import Calendar from "Pages/Calendar/Calendar";

function AllRoutes() {
  const { isSignedIn, user, isLoaded } = useUser();
  const location = useLocation();

  const { createChallengeLoading } = useSelector(
    (state) => state.ChallengeSetupReducer
  );

  const dispatch = useDispatch();
  useEffect(() => {
    setupNotifications(dispatch);
  }, []);
  const { getToken } = useAuth();
  const navigate = useNavigate();

  const { createChallengeSuccess } = useSelector(
    (state) => state.ChallengeSetupReducer
  );
  useEffect(() => {
    if (
      localStorage.getItem("challengeTypeId") &&
      localStorage.getItem("currencyId") &&
      localStorage.getItem("platformId") &&
      localStorage.getItem("balanceId") &&
      localStorage.getItem("accountTypeId") &&
      !createChallengeLoading
    ) {
      dispatch(
        createChallenge(
          getToken,
          {
            challengeTypeId: localStorage.getItem("challengeTypeId"),
            currencyId: localStorage.getItem("currencyId"),
            platformId: localStorage.getItem("platformId"),
            balanceId: localStorage.getItem("balanceId"),
            accountTypeId: localStorage.getItem("accountTypeId"),
            isFree: true,
          },
          navigate
        )
      );
    }
  }, [isSignedIn]);

  if (!isLoaded) {
    return <Loading />;
  }

  return (
    <>
      {isLoaded &&
        (isSignedIn ? (
          <Layout>
            <Routes location={location} key={location.pathname}>
              <Route path="/" element={<Home />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/certificate/:id" element={<SingleCertificate />} />
              <Route path="/certificates" element={<Certificates />} />
              <Route path="/createChallenge" element={<CreateChallenge />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route
                path="/createPaidChallenge"
                element={<CreatePaidChallenge />}
              />

              <Route
                path="/createWelcomeChallenge"
                element={<CreatePaidChallenge />}
              />
              <Route
                path="/createdSuccessfully"
                element={<ChallengeCreatedSuccessfully />}
              />
              <Route
                path="createPaidChallenge/stripe"
                element={<StripePayment />}
              />
              {/* <Route
                  path="/createChallenge/test"
                  element={<CreateChallengeTest />}
                /> */}
              <Route path="/landing" element={<ChallengeLanding />} />
              <Route
                path="/challenge/:id/trades"
                element={<ChallengeTrades />}
              />
              <Route
                path="/inProgressCreation"
                element={<InProgressCreation />}
              />
              {/* <Route
                  path="/challengeBilling"
                  element={<ChallengeBilling />}
                /> */}
              <Route path="/challenge/:id/rules" element={<ChallengeRules />} />
              <Route
                path="/challenge/:id/overview"
                element={<ChallengeOverview />}
              />
              <Route path="purchaseAddon/stripe" element={<StripeAddon />} />
              <Route
                path="/challenge/:id/performance"
                element={<ChallengePerformance />}
              />

              <Route path="/notifications" element={<NotificationPage />} />
              <Route path="/wallet" element={<Wallet />} />
              <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/termsNConditions" element={<TermsNConditions />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        ) : (
          <Routes>
            <Route path="/:id/:name" element={<Login />} />
            <Route path="/" element={<Login />} />

            <Route path="/Welcome" element={<Login welcome={true} />} />
            <Route
              path="/certificate/:id"
              element={<SingleCertificate withoutLogin />}
            />
            <Route
              path="/inProgressCreation"
              element={<InProgressCreation welcome />}
            />
            <Route path="/landing" element={<CreateChallenge fromLanding />} />
            <Route
              path="/createWelcomeChallenge"
              element={<CreatePaidChallenge all />}
            />
            <Route
              path="createPaidChallenge/stripe"
              element={<StripePayment />}
            />
            <Route path="purchaseAddon/stripe" element={<StripeAddon />} />

            <Route path="/auth/Login" element={<Login />} />
            <Route path="/auth/OtpVerification" element={<OtpVerification />} />
            <Route path="/auth/loginLink" element={<LoginLink />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicy all />} />
            <Route
              path="/termsNConditions"
              element={<TermsNConditions all />}
            />
            <Route path="*" element={<NotFound all />} />
          </Routes>
        ))}
      <Toaster
        duration={5000}
        theme="dark"
        toastOptions={{
          classNames: {
            error: "bg-background",
            success: " bg-background text-black",
            warning: "bg-background ",
            info: "bg-background ",
          },
        }}
      />
    </>
  );
}

export default AllRoutes;
